import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { useRateCalculations } from '../hooks/useRateCalculations';

type Props = {
  source: string;
  show12hRatesFields: boolean;
  inheritedSettings: any;
};

export const ChargeRateCentsInput = ({ source, show12hRatesFields, inheritedSettings }: Props) => {
  const { handlers } = useRateCalculations({ source, inheritedSettings });

  return (
    <MoneyInput
      source={`${source}.charge_rate_cents`}
      label={show12hRatesFields ? '8hr Charge Rate' : 'Location Rate'}
      onChange={(event) => handlers.handleChargeRateChange(event.target.value)}
    />
  );
};
